export default () => ({
  isShown: false,
  paymentMethodsList: [],
});
